module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_yogiyo_m2.f76572d55884722f3f31c1a71fe1254b.png";